import React from 'react';
import { CLIENT_LOGOS } from '../mock';

const ClientMarquee = () => {
  return (
    <section className="py-14 bg-[#0b0b0d] border-y border-white/5">
      <div className="max-w-[1440px] mx-auto">
        <p className="text-center section-label mb-8">Over 1,000 projects delivered for clients including</p>
        <div className="marquee">
          <div className="marquee-track">
            {[...CLIENT_LOGOS, ...CLIENT_LOGOS].map((logo, idx) => (
              <div key={idx} className="logo-slide flex items-center justify-center h-28 shrink-0">
                <img
                  src={logo.src}
                  alt={logo.name}
                  className="max-h-24 w-auto object-contain opacity-95 hover:opacity-100 hover:scale-105 transition-all"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientMarquee;
